import { useMapsLibrary } from "@vis.gl/react-google-maps";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

const FindAddressModal = ({ findAddress, onCancelSearch, current }) => {
  const [address, setAddress] = useState(null);
  const coreLib = useMapsLibrary("core");
  const mapsLib = useMapsLibrary("maps");
  const geocodingLib = useMapsLibrary("geocoding");

  useEffect(() => {
    if (findAddress) {
      getReverseGeocodingData(
        current.lastPosition?.latitude,
        current.lastPosition?.longitude
      );
    }
  }, [findAddress]);

  const getReverseGeocodingData = (lat, lng) => {
    let latlng = new coreLib.LatLng(lat, lng);
    let geocoder = new geocodingLib.Geocoder();
    geocoder.geocode({ latLng: latlng }, (results, status) => {
      if (status !== geocodingLib.GeocoderStatus.OK) {
        alert(status);
      }
      // This is checking to see if the Geoeode Status is OK before proceeding
      if (status === geocodingLib.GeocoderStatus.OK) {
        setAddress(results[0].formatted_address);
      }
    });
  };

  return (
    <React.Fragment>
      <Modal
        show={findAddress}
        onHide={() => {
          onCancelSearch && onCancelSearch();
          setAddress(null);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Address Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {address ? <p>{address}</p> : <p>Searching for address...</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              onCancelSearch && onCancelSearch();
              setAddress(null);
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default FindAddressModal;
